// Dmfuture.jsx
import React, { useEffect, useRef, useState } from "react";
import "../Style/Dmfuture.css";

import Aimage from "../assets/A.png";
import Dimage from "../assets/D.png";
import pimage from "../assets/P.png";
import mimage from "../assets/M.png";
import cimage from "../assets/C.png";

const services = [
  {
    id: 1,
    icon: Aimage,
    alt: "AI-Powered Marketing Strategies",
    title: "AI-Powered Marketing Strategies",
    text: "Leverage artificial intelligence and machine learning to automate campaigns, improve audience targeting, predict customer behavior, and maximize marketing performance across multiple digital channels.",
    row: "top",
  },
  {
    id: 2,
    icon: Dimage,
    alt: "Data-Driven Decision Making",
    title: "Data-Driven Decision Making",
    text: "We analyze campaign performance, customer insights, and market trends to make informed marketing decisions that continuously improve traffic, engagement, and conversion rates.",
    row: "top",
  },
  {
    id: 3,
    icon: pimage,
    alt: "Personalized Customer Experiences",
    title: "Personalized Customer Experiences",
    text: "Deliver personalized marketing campaigns based on customer interests, behaviors, and preferences to improve engagement, customer satisfaction, and long-term brand loyalty.",
    row: "top",
  },
];

const Dmfuturee = () => {
  const sectionRef = useRef(null);
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setIsVisible(true);
          observer.disconnect();
        }
      },
      { threshold: 0.12 }
    );

    if (sectionRef.current) observer.observe(sectionRef.current);
    return () => observer.disconnect();
  }, []);

  return (
    <section
      className={`dmfuture-main-section ${isVisible ? "dmfuture-visible" : ""}`}
      ref={sectionRef}
    >
      <div className="dmfuture-glow dmfuture-glow-1" aria-hidden="true" />
      <div className="dmfuture-glow dmfuture-glow-2" aria-hidden="true" />

      <div className="dmfuture-main-container">
        <span className="dmfuture-eyebrow dmfuture-anim dmfuture-anim-0">
          Our Approach
        </span>

        {/* Heading */}
        <h1 className="dmfuture-main-title dmfuture-anim dmfuture-anim-1">
          The Future of Digital Marketing Services
        </h1>

        {/* Delivered by */}
        <p className="dmfuture-subtitle-label dmfuture-anim dmfuture-anim-2">
          Delivered by MPeoples
        </p>

        {/* Description */}
        <p className="dmfuture-main-description dmfuture-anim dmfuture-anim-3">
          Digital marketing continues to evolve with artificial intelligence,
          automation, advanced analytics, and changing consumer behavior. At
          MPeoples, we combine innovative technology with data-driven
          strategies to help businesses improve online visibility, generate
          qualified leads, and achieve sustainable digital growth.
        </p>

        {/* Cards Grid */}
        <div className="dmfuture-card-grid">
          {/* Top row — 3 cards */}
          {services
            .filter((s) => s.row === "top")
            .map((service, i) => (
              <div
                key={service.id}
                className={`dmfuture-service-card dmfuture-anim dmfuture-anim-${4 + i}`}
              >
                <div className="dmfuture-card-header">
                  <div className="dmfuture-card-icon-wrap">
                    <img
                      src={service.icon}
                      alt={service.alt}
                      className="dmfuture-card-icon"
                    />
                  </div>
                  <h3 className="dmfuture-card-title">{service.title}</h3>
                </div>
                <p className="dmfuture-card-text">{service.text}</p>
              </div>
            ))}

          {/* Bottom row — 2 cards */}
          <div className="dmfuture-service-card dmfuture-card-bottom-left dmfuture-anim dmfuture-anim-7">
            <div className="dmfuture-card-header">
              <div className="dmfuture-card-icon-wrap">
                <img
                  src={mimage}
                  alt="Multi-Platform Brand Presence"
                  className="dmfuture-card-icon"
                />
              </div>
              <h3 className="dmfuture-card-title">
                Multi-Platform Brand Presence
              </h3>
            </div>
            <p className="dmfuture-card-text">
              Build a strong online presence across Google Search, social
              media platforms, email marketing, local listings, and content
              channels to ensure consistent brand visibility.
            </p>
          </div>

          <div className="dmfuture-service-card dmfuture-card-bottom-right dmfuture-anim dmfuture-anim-8">
            <div className="dmfuture-card-header">
              <div className="dmfuture-card-icon-wrap">
                <img
                  src={cimage}
                  alt="Continuous Growth & Optimization"
                  className="dmfuture-card-icon"
                />
              </div>
              <h3 className="dmfuture-card-title">
                Continuous Growth &amp; Optimization
              </h3>
            </div>
            <p className="dmfuture-card-text">
              Our digital marketing experts continuously monitor campaign
              performance, optimize strategies, improve ROI, and adapt to
              market changes for long-term business growth.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Dmfuturee;